const normalizeRussianPhoneDigitString = (digits: string): string => {
  let d = digits;
  if (d.startsWith('8')) {
    d = '7' + d.slice(1);
  } else if (d.startsWith('9') && d.length >= 10) {
    d = '7' + d;
  }
  if (d.length > 11) d = d.substring(0, 11);
  return d;
};

const formatRussianPhoneDigits = (digits: string): string => {
  const d = normalizeRussianPhoneDigitString(digits);

  let formatted = '+7';
  if (d.length > 1) formatted += ' (' + d.slice(1, 4);
  if (d.length > 4) formatted += ') ' + d.slice(4, 7);
  if (d.length > 7) formatted += '-' + d.slice(7, 9);
  if (d.length > 9) formatted += '-' + d.slice(9, 11);
  return formatted;
};

const isRussianPhoneDigits = (digits: string): boolean => {
  return (
    digits.startsWith('7') ||
    digits.startsWith('8') ||
    (digits.startsWith('9') && digits.length >= 10)
  );
};

export const formatRussianPhoneMaskValue = (originalValue: string): string => {
  const digits = originalValue.replace(/\D/g, '');

  if (digits === '') {
    return '';
  }
  if (isRussianPhoneDigits(digits)) {
    return formatRussianPhoneDigits(digits);
  }
  return '+' + digits;
};

export const normalizeRussianPhoneDigits = (originalValue: string): string => {
  const digits = originalValue.replace(/\D/g, '');
  if (digits === '') {
    return '';
  }
  if (isRussianPhoneDigits(digits)) {
    return normalizeRussianPhoneDigitString(digits);
  }
  return digits;
};

export const initializePhoneMask = (id: string): void => {
  const phoneInput = document.getElementById(id) as HTMLInputElement;
  if (!phoneInput) return;

  phoneInput.addEventListener('input', function (e) {
    const input = e.target as HTMLInputElement;
    const selectionStart = input.selectionStart || 0;
    const originalValue = input.value;

    const formattedValue = formatRussianPhoneMaskValue(originalValue);

    input.value = formattedValue;

    const afterValue = formattedValue;

    const beforeCursorDigits = originalValue.slice(0, selectionStart).replace(/\D/g, '').length;
    let pos = 0;
    let digitsCount = 0;

    for (let i = 0; i < afterValue.length; i++) {
      if (/\d/.test(afterValue[i])) digitsCount++;
      if (digitsCount === beforeCursorDigits) {
        pos = i + 1;
        break;
      }
    }

    pos = Math.min(pos, afterValue.length);

    requestAnimationFrame(() => {
      input.setSelectionRange(pos, pos);
    });
  });

  phoneInput.addEventListener('blur', () => {
    const digits = phoneInput.value.replace(/\D/g, '');
    if (digits.length > 0 && digits.length < 7) {
      phoneInput.classList.add('is-invalid');
    } else {
      phoneInput.classList.remove('is-invalid');
    }
  });

  phoneInput.addEventListener('focus', () => {
    phoneInput.classList.remove('is-invalid');
  });
};
